module.exports = __webpack_public_path__ + "static/sift-devices-landing-aaad5ccc19147d6c04acbf37e3fc22b6.png";